export default "__VITE_ASSET__Bk0jz8lR__"